/**
 * Custom slider
 */
'use strict'

// console.log('Custom slider');

function customSlider() {
  const sliders = document.querySelectorAll('.custom-slider');
  sliders.forEach(slider => {
    const sliderContainer = slider.querySelector('.slider-container>.group-block-content');
    if (!sliderContainer) return;
    console.log('The custom slider is active');
    const gap = Number(getComputedStyle(sliderContainer).gap.replace(/[^0-9.]/g, '')); // .replace(/\D+/g, ''));

    const slides = sliderContainer.querySelectorAll('.image-block');
    const step = slides.length ? slides[0].getBoundingClientRect().width : null;

    let sliderRect = slider.getBoundingClientRect();
    let rect = sliderContainer.getBoundingClientRect();

    const nextBtn = slider.querySelector('.slideshow-control--next');
    const prevBtn = slider.querySelector('.slideshow-control--previous');

    prevBtn?.setAttribute('disabled', '');

    function btnDisabled(n, r1, r2) {
      n === 0 ? prevBtn.setAttribute('disabled', '') : prevBtn.removeAttribute('disabled');
      r1.right - step <= r2.right ? nextBtn.setAttribute('disabled', '') : nextBtn.removeAttribute('disabled');
    }

    let n = 0;
    let shift = null;

    function updateSlider(direction) {
      const sliderRect = slider.getBoundingClientRect();
      const rect = sliderContainer.getBoundingClientRect();

      if (direction === 'next') {
        prevBtn.removeAttribute('disabled');
        if (rect.right > sliderRect.right && n < slides.length - 1) n++;
      } else if (direction === 'prev') {
        setTimeout(() => { nextBtn.removeAttribute('disabled'); }, 0);
        if (rect.left + step < sliderRect.left && n > 0) n--;
      }

      const shift = (step + gap) * n;

      sliderContainer.style.transform = `translateX(${-shift}px)`;
      btnDisabled(n, rect, sliderRect);
    }

    nextBtn.addEventListener('click', () => updateSlider('next'));
    prevBtn.addEventListener('click', () => updateSlider('prev'));

    slider.addEventListener('touchstart', handleTouchStart, false);
    slider.addEventListener('touchend', handleTouchEnd, false);

    let xDown = null;
    let yDown = null;

    function handleTouchStart(e) {
      xDown = e.touches[0].clientX;
      yDown = e.touches[0].clientY;
    };

    function handleTouchEnd(e) {
      if (!xDown || !yDown) return;

      let xUp = e.changedTouches[0].clientX;
      let yUp = e.changedTouches[0].clientY;
      let xDiff = xDown - xUp;
      let yDiff = yDown - yUp;

      let sliderRect = slider.getBoundingClientRect();
      let rect = sliderContainer.getBoundingClientRect();

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (xDiff > 0) {
          prevBtn.removeAttribute('disabled');
          if (rect.right > sliderRect.right && n < slides.length - 1) n++;
        } else {
          setTimeout(() => { nextBtn.removeAttribute('disabled'); }, 0);
          if (rect.left + step < sliderRect.left && n > 0) n--;
        }
      } else {
        return;
      }
      xDown = null;
      yDown = null;

      const shift = (step + gap) * n;
      sliderContainer.style.transform = `translateX(${-shift}px)`;
      btnDisabled(n, rect, sliderRect);
    };

    // * Modal slider
    const CHEVRON_RIGHT = `<svg class="chevron-down-light" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 36 36" fill="none">
      <path d="M10.7998 14.4001L17.9998 21.6001L25.1998 14.4001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>`;

    const MODAL_GALLERY_TEMPLATE = `<div id="show-image-modal">
      <span id="modal-close-button">
        <svg class="icon close" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z" fill="#0F0F0F" />
        </svg>
      </span>
      <span class="slider-image-switcher">
        <span class="control-btn prev-btn">${CHEVRON_RIGHT}</span>
        <span class="control-btn next-btn">${CHEVRON_RIGHT}</span>
      </span>
      <div id="modal-inner-container"></div>
    </div>`;
    // data-has="modal-slider"
    function modalGallery() {
      if (slider.getAttribute('data-has') !== 'modal-slider') return;
      const html = document.querySelector('html');
      const section = slider.closest('.shopify-section:not(.header-section):has(.section)');
      slider.insertAdjacentHTML('afterend', MODAL_GALLERY_TEMPLATE);
      const modal = document.getElementById('show-image-modal');
      const modalCloseBtn = document.getElementById('modal-close-button');
      const modalInnerContainer = document.getElementById('modal-inner-container');

      const prevBtn = document.querySelector('.slider-image-switcher .prev-btn');
      const nextBtn = document.querySelector('.slider-image-switcher .next-btn');

      function drawImage(img) {
        modalInnerContainer.innerHTML = '';
        const modalImage = img.cloneNode(true);
        modalInnerContainer.appendChild(modalImage);
        modal.classList.add('active');
        html.style.overflowY = 'hidden';
        section.style.zIndex = '99999';
      }

      function setOpacity(el) {
        setTimeout(() => {
          el = document.querySelector('#modal-inner-container img')
          el.style.opacity = '1';
        }, 100);
      }

      const images = sliderContainer.querySelectorAll('img');
      let n = 0;

      for (let i = 0; i < images.length; i++) {
        images[i].addEventListener('click', () => {
          drawImage(images[i]);
          setOpacity(images[i]);
          n = i;
        });
      }

      nextBtn.addEventListener('click', () => {
        for (let i = 0; i < images.length; i++) {
          if (n < images.length - 1) {
            drawImage(images[n + 1]);
            setOpacity(images[i]);
          }
        }
        if (n < images.length - 1) {
          n++;
          nextBtn.style.opacity = '';
          prevBtn.style.opacity = '';
        } else {
          nextBtn.style.opacity = '0';
        }
      });

      prevBtn.addEventListener('click', () => {
        for (let i = 0; i < images.length; i++) {
          if (n > 0) {
            drawImage(images[n - 1]);
            setOpacity(images[i]);
          }
        }
        if (n > 0) {
          n--;
          nextBtn.style.opacity = '';
          prevBtn.style.opacity = '';
        } else {
          prevBtn.style.opacity = '0';
        }

      });

      function reset() {
        modal.classList.remove('active');
        modalInnerContainer.innerHTML = '';
        html.style.overflowY = '';
        section.style.zIndex = '';
        nextBtn.style.opacity = '';
        prevBtn.style.opacity = '';
        n = 0;
      }

      modalCloseBtn.addEventListener('click', () => {
        reset();
      });

      window.addEventListener('click', (e) => {
        if (e.target === modal) {
          reset();
        }
      });

    }
    modalGallery();

  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, customSlider)
);